export default "__VITE_ASSET__BjP71oNZ__"